import { render } from "./Burgerlijke.vue?vue&type=template&id=34d73140&scoped=true"
import script from "./Burgerlijke.vue?vue&type=script&lang=js"
export * from "./Burgerlijke.vue?vue&type=script&lang=js"

import "./Burgerlijke.vue?vue&type=style&index=0&id=34d73140&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d73140"]])

export default __exports__